import { useEffect, useState } from 'react';

import { styled } from '@mui/material';

import { Modal, useModalWrapperContext } from '@app-velocity/ui';

import { useCurrentUser } from '@app-velocity/libs/auth';

import { I18nResources } from '@app-velocity/i18n';

import { LoginForm } from '../../../../widgets/LoginForm';
import { AuthProviderContext } from '../../../../context/AuthProviderContext';

import { AuthProvider } from '../../../../components/AuthProvider';
import { RegisterForm } from '../../../../widgets/RegisterForm';

const AuthProviderWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  background: 'var(--background-background-color)',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 2,
}));

export const AuthModalContent = () => {
  const { closeModal } = useModalWrapperContext();
  const currentUser = useCurrentUser(true);

  const [formType, setFormType] = useState<'login' | 'register'>('login');
  const [detachedAuthActive, setDetachedAuthActive] = useState<
    'google' | 'figma' | null
  >(null);

  useEffect(() => {
    if (currentUser?.authorized) {
      closeModal();
    }
  }, [currentUser]);

  const title: I18nResources =
    formType === 'login' ? 'users:auth.sign_in' : 'users:auth.sign_up';

  return (
    <Modal>
      <Modal.Header title={title} />
      <Modal.Content>
        <AuthProviderContext.Provider
          value={{
            type: 'detached',
            setFormType,
            providerType: detachedAuthActive,
            setProviderType: setDetachedAuthActive,
          }}
        >
          {detachedAuthActive ? (
            <AuthProviderWrapper>
              <AuthProvider type={detachedAuthActive} />
            </AuthProviderWrapper>
          ) : null}
          {formType === 'login' ? <LoginForm /> : <RegisterForm />}
        </AuthProviderContext.Provider>
      </Modal.Content>
    </Modal>
  );
};
